import React from 'react';
import '../template-file-css/document-file-template.css';


export const RNFI_ClientRights = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RNFI_ClientRights' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'> <center> <h3> <b> RAVENS NEST FOUNDATION INC </b> </h3> </center>
                </p>
                <p className='w-750'> <center> <h4> <b> CLIENT'S RIGHTS </b> </h4> </center>
                </p>

                <p className='w-750'> As a consumer of Ravens Nest Foundation, INC you will be given the opportunity to exercise your rights as follows:
                </p>

                <p className='w-750'>
                    <ol>
                        <li> Right to a humane treatment or habilitation environment that affords reasonable protection from harm, exploitation, and coercion form of
                            discrimination, and free from retaliation, humiliation, and neglect.
                        </li>

                        <li> Right to Individualized care.
                        </li>

                        <li> Right to be free from physical and verbal abuse.
                        </li>

                        <li> Right to be free from the use of physical restraints and seclusion unless it is determined that there are no less restrictive methods of
                            controlling behavior to reasonable ensure the safety of the Consumer and their persons.
                        </li>

                        <li> The Right to reasonable access to care, treatment and services regardless of race, spiritual beliefs, gender, sexual orientation, ethnicity,
                            age social economic status. Language or disability.
                        </li>

                        <li> The right to care, treatment, and services that is considerate and respectful.
                        </li>

                        <li> Right to be promptly and fully informed of any changes in the plan of treatment.
                        </li>

                        <li> The Right to personal dignity.
                        </li>

                        <li> The Right to Privacy.
                        </li>

                        <li> The right to be informed of the agency's rules.
                        </li>

                        <li> The rights to access clinical records and obtained copies.
                        </li>

                        <li> The right to request amendment to clinical record.
                        </li>

                        <li> The right to request restriction on communications.
                        </li>

                        <li> The right to request confidential communications.
                        </li>

                        <li> The right to accounting disclosures.
                        </li>

                        <li> The right to file complaint.
                        </li>

                        <li> The right to inform consent or refusal of services, treatment, concurrent services participation
                            in research, or release of information.
                        </li>

                        <li> The Right to be informed about plan of treatment and to participate in the planning, review and
                            notification of changes in plan.
                        </li>

                        <li> The right to have competent qualified and experienced staff to supervise and carry out the
                            individualized plan.
                        </li>

                        <li> The right to participate in conflict resolution.
                        </li>

                        <li> The right to participate in investigational studies or clinical trials.
                        </li>

                        <li> The Right to be involved in the transitional planning.
                        </li>

                        <li> he right of expression of choice regarding the composition of the service delivery team.
                        </li>

                        <li> The right to access and referral to self-help advocacy support services.
                        </li>

                        <li> The Right to investigate and resolve any alleged infringement of rights.
                        </li>

                        <li> The Right to accept or refuse treatment, unless it is determined that consumer is at risk to self or others.
                        </li>

                        <li> Right to be fully informed of the charges for treatment.
                        </li>

                        <li> Right to be informed of the program's complaint policy and procedures and the right to submit complaints without fear of discrimination or retaliation and to have them investigated by the program within a reasonable period of time.
                        </li>

                        <li> Right to receive a written notice of the address and telephone number of the state licensing authority, i.e, the department, which further explains the responsibilities of licensing the program and investigating Consumer complaint which appear to violate licensing rules.
                        </li>

                        <li> The Right to obtain a copy of the program's most recent completed report of licensing inspection from the program upon written request. The program is not required to release a report until the program has had the opportunity to file a written plan of correction for the violations as provided for in these rules.
                        </li>

                        <li> The Right to retain personal property that does not jeopardize the safety of others, and the responsibility to keep all weapons and illicit and licit drugs away from the facility.
                        </li>

                        <li> The right to determine the right of confidentiality of treatment including substance abuse records and who should be informed about the services, supports, care and treatment I received.
                        </li>
                    </ol>
                </p>

                <p className='w-750'> By signing below I am acknowledging that the above Clients Rights have been explained to me and I have received a copy.
                </p>

                <table>
                    <tr>
                        <td className='signature w-500'> &nbsp; </td>
                        <td className='signature w-250'> </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> [PatientName] Consumer/ Family/Guardian/Representative </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                </table>

                <p className='w-750'> <center> <h3> <b> CONSUMER,S RESPONSIBILITIES </b> </h3> </center>
                </p>

                <p className='w-750'> As a client you and/or your representative are expected to:
                </p>

                <p className='w-750'>
                    <ul>
                        <li> Provide complete and accurate information about your health, including present condition, past illness, hospitalization,
                            medications, natural products and vitamins, and any other matters that pertaining to your health.
                        </li>

                        <li> Provide complete and accurate information including your full name, addresses, home telephone number, date of birth, social
                            security number, insurance carrier, and employer when it is necessary.
                        </li>

                        <li> Ask questions when you do not understand what your doctor or other member of your health care team tell you about your
                            diagnosis or treatment. You should inform your doctor if you anticipate problems, in the following prescribe treatment. Inform
                            your doctor if you are considering alternative therapies.
                        </li>

                        <li> Ask your doctor or nurse what to expect regarding pain and pain management, and work with them to develop pain
                            management plan. You should tell your doctor or nurse about any worries you have about taking pain medication.
                        </li>

                        <li> Keep appointments, be on time for your appointments, and call us as soon as possible if you cannot keep your appointments.
                        </li>

                        <li> Leave valuables at home and bring only those items necessary.
                        </li>

                        <li> Abide by all facility rules and regulations.
                        </li>

                        <li> NO smoking
                        </li>

                        <li> Weapons are prohibited on premises
                        </li>

                        <li> Treat staff, other consumers and visitors wit courtesy and respect.
                        </li>

                        <li> Provide complete and accurate information for insurance claims and work with the facility's administrator to make payment arrangements.
                        </li>

                        <li>  Know your health insurance coverage and related policies concerning required pre-approvals, co-pays, covered services, admissions, and the services covered by our insurance provider.
                        </li>

                        <li> Pay your treatment bills in a timely manner.
                        </li>

                        <li> Ask questions if there is financial issue that you do not understand.
                        </li>
                    </ul>
                </p>

                <p className='w-750'> By signing below I am acknowledging that the above Clients Responsibilities have been explained to
                    me and I have received a copy and agreed to perform my responsibilities.
                </p>

                <p className='w-750'> <center> <h3> <b> RAVENS NEST FOUNDATION INC </b> </h3> </center>
                </p>

                <p className='w-750'> <center> <h4> CONSUMER GRIEVANCE INSTRUCTIONS </h4> </center>
                </p>

                <p className='w-750'> If you have a concern or grievance, we encourage you to bring your concern grievance to the attention of the staff person
                    involved. The staff person will address your concerns and attempt to solve the problem with you.
                </p>

                <p className='w-750'> If you are unable to complete the first step or if your concern or grievance has not been resolved by meeting with the staff
                    person concerned, you may request an interview with that staff person's immediate supervisor. This request may be made in
                    writing, by telephone contact or in person to the Utilization Manager or Clinical Director. Upon receipt of the request, the
                    supervisor will contact you within 48 working hours.
                </p>

                <p className='w-750'> If your concern or grievance is still not resolved to your satisfaction, you may re-contact the supervisor involved and request
                    a mediation session with the assistance of a trained mediator, both parties can try to reach a mutually satisfactory resolution.
                </p>

                <p className='w-750'> If you choose not to have a mediation session, or it does not resolve the issues, you may have a Review Hearing. The
                    Review Hearing will be scheduled within 15 working days of your request. You may have an advocate or supportive person
                    with you. We will keep minutes and provide you with a written response with 5 working days of the meeting.
                </p>

                <p className='w-750'> If your concern or grievance is still not resolved to your satisfaction, please contact the State Advocacy Office at 1-800-715-
                    4225.
                </p>

                <p className='w-750'> <center> <h3> <b> RAVENS NEST FOUNDATION, INC </b> </h3> </center>
                </p>

                <p className='w-750'> <center> <h4> CONSUMER ORIENTATION CHECK LIST </h4> </center>
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Name: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> DOB: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtName' name='txtName' className='add-only' /> </td>
                        <td className='w-375'> <input type='date' id='txtDob' name='txtDob' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Date of Admission: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> ID#: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='date' id='txtAdmission' name='txtAdmission' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtId' name='txtId' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> The following policies and procedures and services applicable for my treatment have been explained to me:
                </p>

                <p className='w-750'>
                    <ol>
                        <li> Consent for assessment and treatment form including expectations of the client and explanation of the no drug/weapon policy.
                        </li>

                        <li> Preliminary treatment plan/Individualized Treatment Plan (if applicable)
                        </li>

                        <li> Relapse contract (if applicable)
                        </li>

                        <li> Client Rights and responsibilities
                        </li> <br />

                        <li> Grievance and complaint policies and procedures, ethical treatment, right to be free, emergency intervention and restraint.
                        </li>

                        <li> Treatment costs
                        </li>

                        <li> Notice of Privacy Practices.
                        </li>

                        <li> Alcohol/Drug Testing Consent Form (if applicable)
                        </li>

                        <li> Random Drug Screening (if applicable)
                        </li>

                        <li> Assessments purpose and process - Intake/Nursing/Behavioral/Diagnostic.
                        </li>

                        <li> Medical and social assessment if applicable
                        </li>

                        <li> Signed Orientation checklist
                        </li>

                        <li> Services, treatment, condition to be treated and expected benefits of treatment.
                        </li>

                        <li> Ravens Nest Foundation, INC hours of operation and access to after hours services. (Treatment Schedule)
                        </li>

                        <li> Ravens Nest Foundation, INC confidential policy.
                        </li>

                        <li> Authorization to release information and disclosure of Protected Health Information
                        </li>

                        <li>  Policies and procedures for behavior management and emergency safety interventions when necessary.
                        </li>

                        <li> Identification of staff that is expected to provide treatment.
                        </li>

                        <li> Information regarding transition of aftercare or other services and 12 step support groups (if Applicable)
                        </li>

                        <li> Substance abuse Pre-assessment and Addiction Severity Index (if applicable)
                        </li>

                        <li> Family/guardian/representative involvement in treatment.
                        </li>

                        <li>  Responsibilities of adhering to treatment and the consequences of non-adherence.
                        </li>

                        <li> Discharge Planning
                        </li>

                        <li> Information regarding transition of aftercare or other services
                        </li>

                        <li> Tour of the facility (non-smoking facility).
                        </li>
                    </ol>
                </p>

                <p className='w-750'> <b> Acknowledgement Form </b>
                </p>

                <p className='w-750'> By signing below, you acknowledge that you have receive, read and understood the policies outlined in this Client Manual. You agree to comply with the policies contained in this Manual and to read and understand any revisions to it and be bound by them. You understand this Manual is intended only as a general reference and is not intended to cover every situation that may arise during your services. This Manual is not a full statement of company policy. Any questions regarding this Manual can be discussed with a Ravens Nest Foundation, Inc. representative.
                </p>

                <p className='w-750'> You acknowledge that this Manual is not intended to create, nor shall be construed as creating, any express or implied contract of services for a definite or specific period of time between you and this Company and/or staff or to otherwise create express or implied legally enforceable contractual obligations on the part of Company concerning any terms, conditions, or privileges of services.
                </p>

                <table>
                    <tr>
                        <td className='signature w-750'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-750'> Signature </td>
                    </tr>
                </table>

            </div>
        </form>

    )
}











